@if (vm$ | async; as vm) {
<div class="generic-confirm-modal">
  <div class="generic-confirm-modal__header">
    <h3 class="modal-title" data-testid="pin-title">Verify your identity</h3>
  </div>
  @if (participant) {
  <div class="generic-confirm-modal__body" [formGroup]="pinValidationForm">
    <div data-testid="pin-header" class="pin-message" data-private>
      {{ participant?.firstName }} {{ participant?.lastName }}, please enter the last 4 digits of
      your Social Security Number to verify your identity.
    </div>
    <div>
      <app-password-input
        data-private
        [dataTestId]="'pin-entry'"
        [errorMessage]="(vm$ | async).message"
        [formControlRef]="pinEntry"
        [label]="'Last 4 digits of SSN'"
        [isFullWidth]="true"
        (keydown)="verifyPinOnEnterKey($event)"
      >
      </app-password-input>
    </div>
    <div>
      @if (vm.showContactSupport) {
      <span class="pin-verification__support">
        Need help? Contact support at <app-support-phone></app-support-phone> or email
        ClearsignSupport&#64;rocketclose.com
      </span>
      }
    </div>
  </div>
  }
  <div class="generic-confirm-modal__footer">
    <app-button-container>
      <app-button
        type="tertiary"
        [isDisabled]="vm.showSpinner"
        [dataTestId]="'pin-cancel'"
        (click)="cancel()"
        (keydown.space)="$event.preventDefault(); cancel()"
        >Cancel</app-button
      >
      <app-button
        type="primary"
        [isDisabled]="vm.showSpinner"
        [dataTestId]="'pin-continue'"
        (click)="verifyPin()"
        (keydown.space)="$event.preventDefault(); verifyPin()"
        >@if (vm.showSpinner === false) {
          <span>Continue</span>
        } @if (vm.showSpinner) {
          <span class="fas fa-spin fa-circle-notch"></span>
        }</app-button
      >
    </app-button-container>
  </div>
</div>
}
